import React, { useEffect, useState } from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface activeSwitchProps {
    handleActiveInactive: any;
    userData: any;
}

const ActiveSwitch = ({ handleActiveInactive, userData }: activeSwitchProps) => {
    const [checked, setChecked] = useState(true);
    const { t } = useTranslation();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
        handleActiveInactive(userData, event.target.checked);
    };

    useEffect(() => {
        setChecked(userData.userActive);
    }, [userData]);

    return (
        // <div style={{ padding: '2rem' }}>
        <FormControlLabel
            control={<Switch checked={checked} onChange={handleChange} color="primary" />}
            label={t('ACTIVE_LABEL')}
        />
        /* <Typography variant="body1">
        The switch is <strong>{checked ? 'ON' : 'OFF'}</strong>.
      </Typography> */
        // </div>
    );
};

export default ActiveSwitch;
